/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios';
// import store from '@/store/';
// import router from '@/router/router';
// import { serialize, toLogin } from '@/util/util';
// import { getToken } from '@/util/auth';
import { Message } from 'element-ui';
import Vue from "vue";
// import NProgress from 'nprogress';
// import qs from 'qs'
// import merge from 'lodash/merge'
// import 'nprogress/nprogress.css';
// import { discoveryMap } from '@/config/env';
// import { platformId } from '@/api/const/index';
//
// let __shouldHandleRespError = true

let request = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

if (process.env.NODE_ENV == 'development') {
  // request.defaults.baseURL = 'https://www.baidu.com';
} else if (process.env.NODE_ENV == 'production') {
  // request.defaults.baseURL = 'https://www.production.com';
}

// NProgress 配置
// NProgress.configure({
//     showSpinner: false
// });
//http request拦截
request.interceptors.request.use(config => {
    // NProgress.start();
    // const meta = (config.meta || {});
    // const isToken = meta.isToken === false;
    // config.headers['h-role-id'] = sessionStorage.getItem('h-role-id') || '';
    // config.headers['h-dept-code'] = sessionStorage.getItem('h-dept-code') || '';
    // config.headers['h-org-code'] = sessionStorage.getItem('h-org-code') || '';
    // //让每个请求携带token
    // if (getToken() && !isToken) {
    //     config.headers['h-token'] = getToken()
    // }
    // discoveryMap.forEach((value, key) => {
    //     config.headers[key] = value
    // })
    // //headers中配置serialize为true开启序列化
    // if (config.method === 'post' && meta.isSerialize === true) {
    //     config.data = serialize(config.data);
    // }
    return config
}, error => {
    return Promise.reject(error)
});

//http response 拦截
request.interceptors.response.use(res => {
    //关闭 progress bar
    // NProgress.done();
    //获取状态码
    const status = res.status;
    const respCode = res.data.code
    const message = res.data.msg || '未知错误';
    // 6001 登录超时  6002在其它地方登录
    // if (respCode === '6002' || respCode === '6001') {
    //     if (__shouldHandleRespError) {
    //         __shouldHandleRespError = false
    //         return MessageBox.alert(message)
    //             .then(() => store.dispatch('FedLogOut'))
    //             .then(() => {
    //                 __shouldHandleRespError = true
    //                 if (process.env.VUE_APP_BASE_URL.substring(7) == window.location.host) {
    //                     router.push({ path: '/login' })
    //                 }
    //                 else {
    //                     toLogin()
    //                 }
    //             });
    //     }
    // }
    if (respCode === '-1') {
        Message({
            message: message,
            type: 'error'
        });
      return Promise.reject(res);
    } else if(respCode === '0') {
      return Promise.resolve(res);
    }
  // 如果请求为非200否者默认统一处理
    // if (status !== 200) {
    //     Message({
    //         message: message,
    //         type: 'error'
    //     });
    //     return Promise.reject(new Error(message))
    // }
}, error => {
    // NProgress.done();
    return Promise.reject(new Error(error));
});


/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
request.adornParams = (params = {}, openDefultParams = true) => {
    var defaults = {
        't': new Date().getTime()
    }
    return openDefultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
request.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
    var defaults = {
        't': new Date().getTime()
    }
    data = openDefultdata ? merge(defaults, data) : data
    return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

request.processResp = (updateMethod, onLoad, done, loading) => {
    return updateMethod().then((res) => {
        if (res.data.code === '0') {
            onLoad()
            Message({
                type: "success",
                message: "操作成功!"
            });
            done();
        } else {
            Message({
                message: res.data.msg,
                type: 'error'
            });
            loading();
        }
    }, error => {
        window.console.log(error);
        loading();
    });
}

export default request;

Vue.prototype.$request = request // ajax请求方法



// WEBPACK FOOTER //
// ./src/util/axios.js